// @ts-check

import { useArrayFilter, useArrayMap } from '@vueuse/core'
import * as _ from 'lodash-es'
import { computed } from 'vue'

/**
 * @param {import('vue').Ref<PayslipItem[]>} payslipItems
 */
export const usePayslipItems = (payslipItems) => {
  const itemsWithAmount = useArrayFilter(
    payslipItems,
    (item) => item.amount.amount !== '0'
  )

  const nonCumulativeItems = useArrayFilter(
    itemsWithAmount,
    (item) => item.group !== 'CUMULATIVE'
  )

  const interestingItems = computed(() =>
    _.intersection(itemsWithAmount.value, nonCumulativeItems.value)
  )

  const highlightedItems = useArrayMap(interestingItems, (item) => ({
    ...item,
    highlight: ['NET_SALARY', 'FINAL_SUM_TO_BE_PAID'].includes(item.name)
  }))

  return {
    payslipItems,
    itemsWithAmount,
    nonCumulativeItems,
    interestingItems,
    highlightedItems
  }
}

export default usePayslipItems
